/*
 * En-tête HYLA — proposition 3 « Recherche et modèles ».
 * Ordinateur : un trait corail glisse sous la rubrique survolée ; une rubrique
 * à sous-menu ouvre son panneau au survol (80 ms d'intention, 200 ms de grâce),
 * au toucher, à Entrée, Espace ou flèche bas ; Tab entre dans le panneau, Échap
 * le ferme. Un clic sur une rubrique déjà ouverte au survol mène à sa page,
 * comme sur le site actuel.
 * Recherche : les produits suggérés tant que le champ est vide, puis les
 * résultats de la recherche prédictive de Shopify dès deux lettres.
 * Téléphone : tiroir à gauche (déplacé dans <body>, hors de l'en-tête collant) ;
 * une rubrique à sous-menu glisse en écran suivant, « Retour » ramène à la liste.
 * Panier : la pastille suit les événements du thème (cart:updated…).
 */
(function () {
  "use strict";
  var doc = document;
  var html = doc.documentElement;
  var reduit = window.matchMedia("(prefers-reduced-motion: reduce)");
  var survol = window.matchMedia("(hover: hover) and (pointer: fine)");
  var FOCUSABLES = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),[tabindex]:not([tabindex="-1"])';
  var instances = [];

  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function apres2images(f) { window.requestAnimationFrame(function () { window.requestAnimationFrame(f); }); }

  function init(section) {
    var entete = section.querySelector("[data-hh]");
    if (!entete || instances.some(function (i) { return i.section === section; })) return;
    var ctrl = new AbortController();
    var sig = { signal: ctrl.signal };
    var inst = { section: section, ctrl: ctrl, tiroir: null, fermerTiroir: null };
    instances.push(inst);

    // ---------- Panneaux ----------
    var panneaux = {};
    $$("[data-hh-panneau]", entete).forEach(function (p) { panneaux[p.getAttribute("data-hh-panneau")] = p; });
    var declencheurs = $$("[data-hh-rubrique]", entete);
    var ouvert = null;
    var ouvertParSurvol = false;
    var minuteurOuverture = 0;
    var minuteurFermeture = 0;
    function declencheur(n) { return declencheurs.filter(function (d) { return d.getAttribute("data-hh-rubrique") === n; })[0]; }

    // Trait corail
    var ligne = entete.querySelector(".hh-bas-ligne");
    var indicateur = entete.querySelector(".hh-indicateur");
    function placer(el) {
      if (!ligne || !indicateur) return;
      if (!el) { ligne.classList.remove("avec-indicateur"); return; }
      var rl = ligne.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      var visible = ligne.classList.contains("avec-indicateur");
      if (!visible) indicateur.style.transition = "none";
      ligne.style.setProperty("--x", (r.left - rl.left) + "px");
      ligne.style.setProperty("--w", r.width + "px");
      if (!visible) { void indicateur.offsetWidth; indicateur.style.transition = ""; }
      ligne.classList.add("avec-indicateur");
    }
    $$(".hh-rubrique", entete).forEach(function (a) {
      a.addEventListener("mouseenter", function () { placer(a); }, sig);
      a.addEventListener("focus", function () { placer(a); }, sig);
      a.addEventListener("blur", function () { if (!ouvert) placer(null); }, sig);
    });
    var listeRubriques = entete.querySelector(".hh-rubriques");
    if (listeRubriques) listeRubriques.addEventListener("mouseleave", function () { placer(ouvert ? declencheur(ouvert) : null); }, sig);
    window.addEventListener("resize", function () { if (ouvert) placer(declencheur(ouvert)); }, sig);

    function ouvrir(n, parSurvol) {
      window.clearTimeout(minuteurFermeture);
      if (ouvert === n) return;
      if (ouvert) fermer(true);
      var p = panneaux[n];
      if (!p) return;
      p.hidden = false;
      apres2images(function () { p.classList.add("est-ouvert"); });
      declencheur(n).setAttribute("aria-expanded", "true");
      ouvert = n;
      ouvertParSurvol = !!parSurvol;
      placer(declencheur(n));
    }
    function fermer(immediat) {
      if (!ouvert) return;
      var n = ouvert;
      var p = panneaux[n];
      declencheur(n).setAttribute("aria-expanded", "false");
      p.classList.remove("est-ouvert");
      ouvert = null;
      if (!immediat) placer(null);
      if (immediat || reduit.matches) { p.hidden = true; return; }
      window.setTimeout(function () { if (ouvert !== n) p.hidden = true; }, 260);
    }
    function planifierFermeture() {
      window.clearTimeout(minuteurOuverture);
      window.clearTimeout(minuteurFermeture);
      minuteurFermeture = window.setTimeout(function () { fermer(); }, 200);
    }
    declencheurs.forEach(function (t) {
      var n = t.getAttribute("data-hh-rubrique");
      t.addEventListener("mouseenter", function () {
        if (!survol.matches) return;
        window.clearTimeout(minuteurFermeture);
        window.clearTimeout(minuteurOuverture);
        minuteurOuverture = window.setTimeout(function () { ouvrir(n, true); }, ouvert ? 0 : 80);
      }, sig);
      t.addEventListener("mouseleave", function () { if (survol.matches) planifierFermeture(); }, sig);
      t.addEventListener("click", function (ev) {
        if (ev.ctrlKey || ev.metaKey || ev.shiftKey || ev.altKey) return;
        if (ouvert === n && ouvertParSurvol && survol.matches) return; // déjà ouvert au survol : on suit le lien
        ev.preventDefault();
        if (ouvert === n) fermer(); else ouvrir(n, false);
      }, sig);
      t.addEventListener("keydown", function (ev) {
        if (ev.key === " ") {
          ev.preventDefault();
          if (ouvert === n) fermer(); else ouvrir(n, false);
        } else if (ev.key === "ArrowDown" || (ev.key === "Tab" && !ev.shiftKey && ouvert === n)) {
          ev.preventDefault();
          ouvrir(n, false);
          var l = panneaux[n] && panneaux[n].querySelector("a");
          if (l) window.setTimeout(function () { l.focus(); }, 0);
        }
      }, sig);
    });
    Object.keys(panneaux).forEach(function (n) {
      var p = panneaux[n];
      p.addEventListener("mouseenter", function () { window.clearTimeout(minuteurFermeture); }, sig);
      p.addEventListener("mouseleave", function () { if (survol.matches) planifierFermeture(); }, sig);
      p.addEventListener("focusout", function (ev) {
        var vers = ev.relatedTarget;
        if (vers && !p.contains(vers) && vers !== declencheur(n)) fermer();
      }, sig);
    });
    doc.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape" && ouvert) { var t = declencheur(ouvert); fermer(); t.focus(); }
    }, sig);
    doc.addEventListener("click", function (ev) {
      if (ouvert && !ev.target.closest("[data-hh-panneau], [data-hh-rubrique]")) fermer();
    }, sig);

    // ---------- Recherche ----------
    var form = entete.querySelector("[data-hh-recherche]");
    if (form) initRecherche(form, sig);

    // ---------- Panier ----------
    var lienPanier = entete.querySelector("[data-hh-panier]");
    var pastille = entete.querySelector("[data-hh-pastille]");
    function libellePanier(n) { return n === 0 ? "Panier vide" : n === 1 ? "Panier, 1 article" : "Panier, " + n + " articles"; }
    function majPanier(n) {
      if (!pastille || typeof n !== "number") return;
      pastille.textContent = n;
      pastille.hidden = n < 1;
      if (lienPanier) lienPanier.setAttribute("aria-label", libellePanier(n));
    }
    function rafraichirPanier() {
      var url = (window.theme && window.theme.routes && window.theme.routes.cart) || "/cart.js";
      fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) { majPanier(c.item_count); })
        .catch(function () {});
    }
    doc.addEventListener("cart:updated", function (e) {
      if (e.detail && e.detail.cart) majPanier(e.detail.cart.item_count); else rafraichirPanier();
    }, sig);
    ["cart:refresh", "cart:build", "ajaxProduct:added"].forEach(function (nom) { doc.addEventListener(nom, rafraichirPanier, sig); });
    window.addEventListener("pageshow", function (e) { if (e.persisted) rafraichirPanier(); }, sig);

    // ---------- Tiroir du téléphone ----------
    var tiroir = section.querySelector("[data-hh-tiroir]");
    if (tiroir) {
      doc.body.appendChild(tiroir);
      inst.tiroir = tiroir;
      var vues = {};
      $$("[data-hh-vue-nom]", tiroir).forEach(function (v) { vues[v.getAttribute("data-hh-vue-nom")] = v; });
      var declencheurTiroir = null;
      var minuteurTiroir = 0;
      var origine = null;
      var focusables = function () { return $$(FOCUSABLES, tiroir).filter(function (e) { return e.getClientRects().length > 0; }); };
      var marquer = function (etat) { $$('[aria-controls="' + tiroir.id + '"]').forEach(function (b) { b.setAttribute("aria-expanded", etat ? "true" : "false"); }); };
      var clavier = function (ev) {
        if (ev.key === "Escape") { ev.preventDefault(); fermerTiroir(); return; }
        if (ev.key !== "Tab") return;
        var f = focusables();
        if (!f.length) return;
        if (ev.shiftKey && doc.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
        else if (!ev.shiftKey && doc.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
      };
      var allerA = function (nom, source) {
        var v = vues[nom];
        var p = vues.principale;
        if (!v) return;
        origine = source;
        v.hidden = false;
        v.classList.add("est-a-droite");
        apres2images(function () {
          v.classList.remove("est-a-droite");
          p.classList.add("est-a-gauche");
        });
        window.setTimeout(function () { if (!v.hidden) p.hidden = true; }, reduit.matches ? 0 : 380);
        var r = v.querySelector("[data-hh-retour]");
        if (r) r.focus({ preventScroll: true });
      };
      var retourPrincipal = function (sansFocus) {
        var p = vues.principale;
        var actives = Object.keys(vues).filter(function (k) { return k !== "principale" && !vues[k].hidden; });
        if (!actives.length) return;
        p.hidden = false;
        apres2images(function () { p.classList.remove("est-a-gauche"); });
        actives.forEach(function (k) {
          var v = vues[k];
          v.classList.add("est-a-droite");
          window.setTimeout(function () { v.hidden = true; v.classList.remove("est-a-droite"); }, reduit.matches ? 0 : 380);
        });
        if (!sansFocus && origine) origine.focus({ preventScroll: true });
      };
      var ouvrirTiroir = function (source) {
        window.clearTimeout(minuteurTiroir);
        declencheurTiroir = source || doc.activeElement;
        tiroir.hidden = false;
        tiroir.classList.remove("se-ferme");
        html.classList.add("hh-verrou");
        marquer(true);
        apres2images(function () { tiroir.classList.add("est-ouvert"); });
        doc.addEventListener("keydown", clavier, sig);
        var f = tiroir.querySelector(".hh-fermer");
        if (f) f.focus({ preventScroll: true });
      };
      var fermerTiroir = function (sansRetour) {
        if (tiroir.hidden || tiroir.classList.contains("se-ferme")) return;
        tiroir.classList.remove("est-ouvert");
        tiroir.classList.add("se-ferme");
        marquer(false);
        doc.removeEventListener("keydown", clavier);
        html.classList.remove("hh-verrou");
        minuteurTiroir = window.setTimeout(function () {
          tiroir.hidden = true;
          tiroir.classList.remove("se-ferme");
          retourPrincipal(true);
        }, reduit.matches ? 0 : 300);
        if (!sansRetour && declencheurTiroir && doc.contains(declencheurTiroir) && declencheurTiroir.getClientRects().length) {
          declencheurTiroir.focus({ preventScroll: true });
        }
      };
      inst.fermerTiroir = fermerTiroir;
      $$("[data-hh-ouvrir-tiroir]", entete).forEach(function (b) { b.addEventListener("click", function () { ouvrirTiroir(b); }, sig); });
      $$("[data-hh-fermer]", tiroir).forEach(function (b) { b.addEventListener("click", function () { fermerTiroir(); }, sig); });
      $$("[data-hh-vue]", tiroir).forEach(function (b) { b.addEventListener("click", function () { allerA(b.getAttribute("data-hh-vue"), b); }, sig); });
      $$("[data-hh-retour]", tiroir).forEach(function (b) { b.addEventListener("click", function () { retourPrincipal(); }, sig); });
    }

    var mq = window.matchMedia("(min-width: 1024px)");
    var surChangement = function (e) { if (e.matches) { if (inst.fermerTiroir) inst.fermerTiroir(true); } else { fermer(true); } };
    if (mq.addEventListener) mq.addEventListener("change", surChangement, sig); else mq.addListener(surChangement);
  }

  // ---------- Recherche : suggestions puis recherche prédictive ----------
  function initRecherche(form, sig) {
    var q = form.querySelector("[data-hh-q]");
    var boite = form.querySelector("[data-hh-suggestions]");
    var titre = form.querySelector("[data-hh-suggestions-titre]");
    var liste = form.querySelector("[data-hh-suggestions-liste]");
    if (!q || !boite || !liste) return;
    var suggestions = Array.prototype.slice.call(liste.children);
    var url = (form.getAttribute("data-hh-suggest") || "/search/suggest") + ".json";
    var cache = {};
    var requete = null;
    var minuteur = 0;

    function montrer(v) {
      boite.hidden = !v;
      q.setAttribute("aria-expanded", v ? "true" : "false");
    }
    function taille(src, l) {
      if (!src) return "";
      return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + l;
    }
    function prix(p) {
      var montant = parseFloat(p);
      if (isNaN(montant)) return "";
      var t = window.theme;
      if (t && t.Currency && t.Currency.formatMoney && t.settings && t.settings.moneyFormat) {
        return t.Currency.formatMoney(Math.round(montant * 100), t.settings.moneyFormat);
      }
      var devise = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
      return new Intl.NumberFormat("fr-FR", { style: "currency", currency: devise }).format(montant);
    }
    function lienTout(terme) {
      var li = doc.createElement("li");
      li.className = "hh-suggestions-tout";
      var a = doc.createElement("a");
      a.href = form.getAttribute("action") + "?q=" + encodeURIComponent(terme) + "&options%5Bprefix%5D=last";
      var s = doc.createElement("span");
      s.className = "hh-u";
      s.textContent = "Voir tous les résultats";
      a.appendChild(s);
      a.insertAdjacentHTML("beforeend", '<svg class="hh-ic" aria-hidden="true" style="width:20px;height:20px"><use href="#hh-i-fleche"/></svg>');
      li.appendChild(a);
      return li;
    }
    function afficherSuggestions() {
      if (!suggestions.length) { montrer(false); return; }
      if (titre) { titre.hidden = false; titre.textContent = titre.getAttribute("data-defaut"); }
      liste.textContent = "";
      suggestions.forEach(function (li) { liste.appendChild(li); });
      montrer(true);
    }
    function afficherResultats(terme, produits) {
      if (titre) { titre.hidden = !produits.length; titre.textContent = "Produits"; }
      liste.textContent = "";
      if (!produits.length) {
        var vide = doc.createElement("li");
        vide.className = "hh-suggestions-message";
        vide.textContent = "Aucun produit pour « " + terme + " ».";
        liste.appendChild(vide);
      }
      produits.forEach(function (p) {
        var li = doc.createElement("li");
        var a = doc.createElement("a");
        a.href = p.url;
        var src = (p.featured_image && p.featured_image.url) || p.image;
        if (src) {
          var img = doc.createElement("img");
          img.src = taille(src, 144);
          img.alt = "";
          img.width = 48;
          img.height = 48;
          img.loading = "lazy";
          a.appendChild(img);
        } else {
          var v = doc.createElement("span");
          v.className = "hh-vide";
          a.appendChild(v);
        }
        var nom = doc.createElement("span");
        nom.textContent = p.title;
        a.appendChild(nom);
        var pr = doc.createElement("span");
        pr.className = "hh-prix";
        pr.textContent = prix(p.price);
        a.appendChild(pr);
        li.appendChild(a);
        liste.appendChild(li);
      });
      liste.appendChild(lienTout(terme));
      montrer(true);
    }
    function chercher(terme) {
      if (cache[terme]) { afficherResultats(terme, cache[terme]); return; }
      if (requete) requete.abort();
      requete = new AbortController();
      var u = url + "?q=" + encodeURIComponent(terme) + "&resources%5Btype%5D=product&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last";
      fetch(u, { signal: requete.signal, headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
        .then(function (j) {
          var produits = (j.resources && j.resources.results && j.resources.results.products) || [];
          cache[terme] = produits;
          if (q.value.trim() === terme && doc.activeElement && form.contains(doc.activeElement)) afficherResultats(terme, produits);
        })
        .catch(function () {});
    }
    function surSaisie() {
      var terme = q.value.trim();
      window.clearTimeout(minuteur);
      if (!terme) { afficherSuggestions(); return; }
      if (terme.length < 2) { montrer(false); return; }
      minuteur = window.setTimeout(function () { chercher(terme); }, 180);
    }
    q.addEventListener("focus", surSaisie, sig);
    q.addEventListener("input", surSaisie, sig);
    form.addEventListener("focusout", function (ev) { if (!form.contains(ev.relatedTarget)) montrer(false); }, sig);
    form.addEventListener("keydown", function (ev) {
      if (boite.hidden) return;
      var liens = $$("a", boite);
      var i = liens.indexOf(doc.activeElement);
      if (ev.key === "Escape") { ev.stopPropagation(); montrer(false); q.focus(); }
      else if (ev.key === "ArrowDown" && liens.length) { ev.preventDefault(); (liens[i + 1] || liens[0]).focus(); }
      else if (ev.key === "ArrowUp" && liens.length) { ev.preventDefault(); if (i <= 0) q.focus(); else liens[i - 1].focus(); }
    }, sig);
    form.addEventListener("submit", function (ev) { if (!q.value.trim()) { ev.preventDefault(); q.focus(); } }, sig);
    doc.addEventListener("click", function (ev) { if (!form.contains(ev.target)) montrer(false); }, sig);
  }

  // Tiroir panier d'Impulse : son en-tête l'initialisait ; on prend le relais
  // si le thème repasse un jour en panier tiroir (aujourd'hui : page panier).
  function initTiroirPanier() {
    var t = window.theme;
    if (!t || !t.settings || t.settings.cartType !== "drawer" || !t.CartDrawer) return;
    if (window.hhTiroirPanier || doc.body.classList.contains("template-cart") || !doc.getElementById("CartDrawer")) return;
    window.hhTiroirPanier = new t.CartDrawer();
  }

  function detruire(section) {
    instances = instances.filter(function (inst) {
      if (inst.section !== section) return true;
      if (inst.fermerTiroir) inst.fermerTiroir(true);
      inst.ctrl.abort();
      if (inst.tiroir && inst.tiroir.parentNode) inst.tiroir.parentNode.removeChild(inst.tiroir);
      html.classList.remove("hh-verrou");
      return false;
    });
  }

  function demarrer() {
    $$(".hh-section").forEach(init);
    initTiroirPanier();
  }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", demarrer); else demarrer();
  doc.addEventListener("shopify:section:load", function (e) { if (e.target.querySelector && e.target.querySelector("[data-hh]")) init(e.target); });
  doc.addEventListener("shopify:section:unload", function (e) { detruire(e.target); });
})();
